import React, { useMemo, useState } from "react";
import { Box, Divider } from "@mui/material";
import { LargeButton, Ptag } from "components/core";
import subtract from "assets/svgs/addDel/subtract.svg";
import addition from "assets/svgs/addDel/add.svg";
import rupee from "assets/svgs/addDel/rupee.svg";
import { formatToRs, newFormatRupees, newFormatRupeesWithDecimals, starLineWrapperJsxW100 } from "utlis/utils";
import useUser from "hooks/useUser";
// import DownloadIcon from "assets/svgs/downloadNew.svg";
import DownloadIcon from "assets/images/downloadcsv.png"
import styled from "styled-components";
import StarSvg from "../../../assets/svgs2026/starIconSvg.svg"
import { Download } from "components/core/BaseTable/styles";
import GlassWrapper from "components/GlassWrapper";
import premCalNoteBg from "../../../assets/svgs2026/premCalNoteBg.svg"
import submitBtnBgImg from "../../../assets/images2026/downloadBtnBgImage.png"


const AddDeleteRow = ({ type, amount, premiumCalcDet }) => {
  const getIcon = (type) => {
    switch (type) {
      case "subtract":
        return addition;
      case "addition":
        return subtract;
      case "rupee":
        return rupee;
    }
  };

  const totalAmountTextHandler = () => {
    const premValue = premiumCalcDet?.total_added_premium || 0;
    const refValue = premiumCalcDet?.total_refund_premium || 0;
    if (premValue > refValue) {
      return "Total Estimated Premium";
    } else if (refValue > premValue) {
      return "Amount to be Credited";
    } else {
      return "Total Amount";
    }
  };

  const textHandler = (type) => {
    if (type === "subtract") {
      return "Refund from Deletions";
    } else if (type === "rupee") {
      // return "Total Amount";
      return totalAmountTextHandler();
    } else {
      return "Insurance Premium";
    }
  };

  const amountHandler = (amount, type) => {
    if (amount && type === "rupee") {
      return newFormatRupeesWithDecimals(amount);
    } else if (amount && type !== "rupee") {
      return newFormatRupeesWithDecimals(amount);
    } else {
      return "-";
    }
  };

  return (
    <section
      style={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "14px",
        }}
      >
        <Box sx={{ position: "relative", top: "-3px" }}>
          <img src={getIcon(type)} alt="" />
        </Box>
        <div>
          <div>
            <span className="premium-cal-section-headings-css">
              {textHandler(type, amount)}
            </span>
          </div>
          <div>
            {/* <Ptag
              fontSize="12px"
              color="#4A4A4A"
              fontWeight="400"
              marginTop="5px"
            >
              (incl. 18% GST)
            </Ptag> */}
            <span className="premium-cal-section-small-info-css">
              (incl. 18% GST)
            </span>
          </div>
        </div>
      </div>
      {/* <Ptag fontSize="16px" fontWeight="600" color="#4a4a4a">
        {amountHandler(amount, type)}
      </Ptag> */}
      <span className="premium-cal-section-amount-css">
        {amountHandler(amount, type)}
      </span>
    </section>
  );
};

function PremiumCalc({ premiumCalcDet, showPremiumSubmitBtn }) {
  const { getRole } = useUser();
  const role = getRole();

  const totalAmount = useMemo(() => {
    const premium = premiumCalcDet?.total_added_premium || 0;
    const refund = premiumCalcDet?.total_refund_premium || 0;
    // return premium - refund;
    return Math.abs(refund - premium).toFixed(2);
  }, [premiumCalcDet]);

  const showDisplayBtn = () => {
    return (
      <>
        {role !== "admin" && showPremiumSubmitBtn && (
        <LargeButton
          type="submit"
          style={{
            borderRadius: "7px",
            marginTop: "42px",
            backgroundImage: `url(${submitBtnBgImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
          label="Submit"
          customLabelCss="prem-submit-btn-text-css"
        />
        )}
      </>
    );
  };

  return (
    <div>
      {premiumCalcDet && (
        <>
          {/* <Divider
            sx={{
              borderColor: "black",
            }}
          /> */}
          <header
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "47px"
            }}
          >
            {starLineWrapperJsxW100(
              <span className="premium-calc-css">
                {"Premium Calculations"}
              </span>
            )}
            {/* <DownloadButton
              onClick={() => {
                window.open(premiumCalcDet?.premium_excel_file, "_blank");
              }}
            >
              <img
                style={{ marginRight: "3px", height: "16px", width: "16px" }}
                src={DownloadIcon}
              />
              <Ptag
                textAlign="center"
                fontSize="14px"
                fontWeight="600"
                color="white"
              >
                Estimated Premium
              </Ptag>
            </DownloadButton> */}

            <Download
              onClick={() => {
                window.open(premiumCalcDet?.premium_excel_file, "_blank");
              }}
              style={{
                // width: "280px",
                whiteSpace: "nowrap",
                marginRight: "0px",
                display: "flex",
                gap: "15px"
              }}
            >
              <span className="mis-download-div-text">
                {"Estimated Premium"}
              </span>
              <GlassWrapper className="glass-xl glass-wrapper-no-width">
                <img
                  src={DownloadIcon}
                  width="18px"
                  height="18px"
                  style={{ margin: "4px", padding: "1px" }}
                />
              </GlassWrapper>
            </Download>

          </header>
          <div
            style={{
              // background: "white",
              borderRadius: "10px",
              padding: "36px",
              border: "1px solid rgba(255, 255, 255, 1)",
              boxShadow: "inset 2px 2px 5px rgba(0, 0, 0, 0.08), inset -1px -1px 3px rgba(255, 255, 255, 0.9)"
            }}
          >
            <section
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "14px",
              }}
            >
              <AddDeleteRow
                type="addition"
                amount={premiumCalcDet?.total_added_premium || 0}
              />
              <AddDeleteRow
                type="subtract"
                amount={premiumCalcDet?.total_refund_premium || 0}
              />
            </section>
            <Divider
              sx={{
                borderColor: "rgba(0, 0, 0, 0.2)",
                margin: "24px 0px",
              }}
            />
            <AddDeleteRow
              type="rupee"
              amount={totalAmount}
              premiumCalcDet={premiumCalcDet}
            />
          </div>
          <footer
            style={{
              borderRadius: "5px",
              // background: "rgba(253, 189, 12, 0.46)",
              padding: "30px 24px",
              marginTop: "42px",
              backgroundImage: `url(${premCalNoteBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <span className="prem-calc-note-heading">
              Note:
            </span>
            {/* <Ptag color="#4a4a4a" fontWeight="400">
          Please ensure your CD Balance is adequate. That will ensure seamless
          endorsements and policy generation. We recommend you keep an
          additional 10% amount in the CD account to avoid last-minute hassles
          in additions/deletions.
        </Ptag> */}
            <div
              style={{
                marginTop: "10px",
                marginLeft: "24px"
              }}
              // sx={{
              //   padding: "10px 10px 0px 15px",
              //   fontFamily: "Inter",
              //   fontSize: "12px",
              //   color: "#4a4a4a",
              //   lineHeight: "22px",
              // }}
            >
              <ol className="prem-calc-note-bullets-css">
                <li>
                  The date of enrollment should be within the policy period.
                </li>
                <li>
                  Midterm dependent additions to the policy are allowed only for
                  a newly married spouse and newborn children.
                </li>
                <li>
                  Any new enrollment (employee joining or dependent addition)
                  must be intimated and endorsed within 30 days.
                </li>
                <li>
                  Please maintain an adequate CD balance to ensure policy
                  coverage and seamless endorsements.
                </li>
                <li>
                  We recommend keeping an additional 10% amount in the CD
                  account to ensure coverage from inception.
                </li>
                <li>
                  The premium mentioned is indicative and subject to agreed
                  policy terms.
                </li>
                <li>
                  Coverage is subject to the agreed terms and conditions of the
                  policy.
                </li>
              </ol>
            </div>
          </footer>
        </>
      )}
      {showDisplayBtn()}
    </div>
  );
}

export default PremiumCalc;

export const DownloadButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  gap: 2px;
  background-color: ${(props) => props.theme.accentColor};
  /* margin-top: 24px; */
  padding: 20px;
  cursor: pointer;
  max-width: 40%;
  height: 36px;
`;
